<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>{{ 'Persone' | translate }}</mat-card-title>
    <mat-card-content>
      <ui-table
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [filters]="filters$ | async"
        [pager]="pager$"
        [reload]="reload$"
        [contextMenuActions]="personContextMenus"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="Persona"
            [config]="{ showAddToCollection: false, showExport: false }"
            [selectedItemsCount]="selectedItems?.length"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-people-filters
              [filters]="filtersObj$ | async"
              #desktopFilter>
            </app-people-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
